import APIClient from '@/shared/http/clients/api'

const resourceName = 'environment'
const APIAccess = process.env.APIBaseURLCore

const getEnv = (data = {}, config = {}) => APIClient.get(`${APIAccess}/${resourceName}/`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APIAccess}/${resourceName}/`, data, config)
const getBackgroundImage = (data = {}, config = {}) => APIClient.get(`${APIAccess}/${resourceName}/background`, data, config)
const getLogoImage = (data = {}, config = {}) => APIClient.get(`${APIAccess}/${resourceName}/logo`, data, config)

const EnvironmentRepository = {
  getEnv,
  Update,
  getBackgroundImage,
  getLogoImage
}

export default EnvironmentRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/access/environment.js